import AbilityScoreCalculations from './AbilityScoreCalculations';

export default AbilityScoreCalculations;
export { AbilityScoreCalculations };
